define('TescoMobile_Checkout/js/catalog-add-to-cart-mixin',['jquery', 'ko', 'mage/translate', 'underscore', 'mage/template', 'mage/url', 'mage/storage', 'Magento_Ui/js/modal/confirm', 'text!TescoMobile_Checkout/template/limit-modal.html', 'Magento_Catalog/js/product/view/product-ids-resolver', 'Magento_Catalog/js/product/view/product-info-resolver', 'Magento_Customer/js/customer-data', 'jquery-ui-modules/widget', 'domReady!'], function ($, ko, $t, _, mageTemplate, urlBuilder, storage, confirmModal, limitTmp, idsResolver, productInfoResolver, customerData) {
  'use strict';

  var mixin = {
    quoteType: ko.observable(''),
    typeQuoteMigration: ko.observable(false),
    typeQuoteUpgrade: ko.observable(false),
    addNewContract: ko.observable(false),
    actionUpgrade: ko.observable(false),
    isLoginJourney: ko.observable(false),
    formData: null,
    upgradeModalElement: null,
    _create: function () {
      var self = this;
      if (this.options.bindSubmit) {
        this._bindSubmit();
      }
      $(this.options.addToCartButtonSelector).attr('disabled', false);
      $('body').on('customer-login-new', function (e) {
        self.actionUpgrade(false);
        self.ajaxSubmit(self.formData);
      });
      $('body').on('customer-login-paym', function (e) {
        self.typeQuoteMigration(true);
        self.actionUpgrade(false);
      });
      $('body').on('add-to-cart-upgrade', function (e) {
        self.typeQuoteUpgrade(true);
        self.actionUpgrade(true);
      });
      $('body').on('add-new-contract', function (e) {
        self.addNewContract(true);
        self.actionUpgrade(false);
      });
      $('body').on('upgrade-popup-closed', function (e) {
        if (self.isLoggedIn()) {
          $('body').loader('hide');
          self.enableAddToCartButtonNoAdded(self.formData);
        }
      });
      $('body').on('login-popup-closed', function (e) {
        if (!self.isLoggedIn()) {
          $('body').loader('hide');
          self.enableAddToCartButtonNoAdded(self.formData);
        }
      });
      $('body').on('customer-login-existing', function (e) {
        self.isLoginJourney(true);
      });
      $('body').on('prompt-customer-modal-closed', function (e) {
        if (!self.isLoginJourney()) {
          $('body').loader('hide');
          self.enableAddToCartButtonNoAdded(self.formData);
        }
      });
      $('body').on('customer-selected-item-type', function (e, elem) {
        self.upgradeModalElement = elem;
      });
      $('body').on('close-all-modals-keep-loader', function (e, elem) {
        $('body').loader('show');
      });
    },
    enableAddToCartButtonNoAdded: function (form) {
      var self = this,
        addToCartButton = $(form).find(this.options.addToCartButtonSelector);
      setTimeout(function () {
        var addToCartButtonTextDefault = self.options.addToCartButtonTextDefault || $t('Add to Cart');
        addToCartButton.removeClass(self.options.addToCartButtonDisabledClass);
        addToCartButton.find('span').text(addToCartButtonTextDefault);
        addToCartButton.attr('title', addToCartButtonTextDefault);
      }, 1000);
    },
    _ajaxSubmitAction: function (form) {
      var self = this,
        productIds = idsResolver(form),
        productInfo = self.options.productInfoResolver(form),
        isUpgrade = self.actionUpgrade(),
        formData;
      $('body').trigger('upgrade-options-submited');
      $(self.options.minicartSelector).trigger('contentLoading');
      $('body').loader('show');
      $('body').trigger('close-all-modals-keep-loader');
      formData = new FormData(form[0]);
      formData.append('upgrade', isUpgrade);
      $.ajax({
        url: form.attr('action'),
        data: formData,
        type: 'post',
        dataType: 'json',
        cache: false,
        contentType: false,
        processData: false,
        beforeSend: function () {
          self.actionUpgrade(false);
          if (self.isLoaderEnabled()) {
            $('body').trigger(self.options.processStart);
          }
        },
        success: function (res) {
          var eventData, parameters;
          $(document).trigger('ajax:addToCart', {
            'sku': form.data().productSku,
            'productIds': productIds,
            'productInfo': productInfo,
            'form': form,
            'response': res
          });
          if (self.isLoaderEnabled()) {
            $('body').trigger(self.options.processStop);
          }
          if (res.backUrl) {
            eventData = {
              'form': form,
              'redirectParameters': []
            };
            $('body').trigger('catalogCategoryAddToCartRedirect', eventData);
            if (eventData.redirectParameters.length > 0 && window.location.href.split(/[?#]/)[0] === res.backUrl) {
              parameters = res.backUrl.split('#');
              parameters.push(eventData.redirectParameters.join('&'));
              res.backUrl = parameters.join('#');
            }
            if (self.quoteType().indexOf('PAYG_MIGRATION') >= 0) {
              self.markQuoteType(res, 'PAYG_MIGRATION');
            } else if (self.quoteType().indexOf('UPGRADE') >= 0) {
              self.markQuoteType(res, 'UPGRADE');
            } else if (self.quoteType().indexOf('NEW_CONTRACT') >= 0) {
              self.markQuoteType(res, 'NEW_CONTRACT');
            } else {
              self._redirect(res.backUrl);
            }
            return;
          }
          if (res.messages) {
            $(self.options.messagesSelector).html(res.messages);
          }
          if (res.minicart) {
            $(self.options.minicartSelector).replaceWith(res.minicart);
            $(self.options.minicartSelector).trigger('contentUpdated');
          }
          if (res.product && res.product.statusText) {
            $(self.options.productStatusSelector).removeClass('available').addClass('unavailable').find('span').html(res.product.statusText);
          }
          $('body').loader('hide');
          self.upgradeModalElement.isLoading(false);
          self.enableAddToCartButton(form);
        },
        error: function (res) {
          $(document).trigger('ajax:addToCart:error', {
            'sku': form.data().productSku,
            'productIds': productIds,
            'productInfo': productInfo,
            'form': form,
            'response': res
          });
          $('body').loader('hide');
        },
        complete: function (res) {
          if (res.state() === 'rejected') {
            location.reload();
          }
        }
      });
    },
    cancelPendingOrder: function (form, orderId, actionToTrigger) {
      $.ajax({
        url: urlBuilder.build('checkout/cart/cancelpendingorder'),
        data: {
          'order_id': orderId
        },
        type: 'post',
        dataType: 'json',
        cache: false,
        success: function (result) {
          if (result.error === false) {
            this.triggerAddAction(actionToTrigger);
            this.ajaxSubmit(form);
          } else {
            confirmModal({
              title: $t('Sorry, we were unable to cancel your order.'),
              clickableOverlay: true,
              buttons: [{
                text: $.mage.__('Ok'),
                click: function (event) {
                  this.closeModal(event, true);
                }
              }]
            });
          }
        }.bind(this)
      });
    },
    markQuoteType: function (res, type) {
      $.ajax({
        url: urlBuilder.build('checkout/cart/markquotetype'),
        data: {
          'type': type,
          'item_id': res.tm_quote.item_id
        },
        type: 'post',
        dataType: 'json',
        cache: false,
        success: function (result) {
          this._redirect(res.backUrl);
        }.bind(this)
      });
    },
    resetCurrentQuote: function (form) {
      $.ajax({
        url: urlBuilder.build('checkout/cart/resetcurrentquote'),
        showLoader: true,
        type: 'post',
        dataType: 'json',
        cache: false,
        success: function (result) {
          this._ajaxSubmitAction(form);
        }.bind(this)
      });
    },
    ajaxSubmit: function (form) {
      var self = this,
        formData;
      if (form) {
        formData = new FormData(form[0]);
      }
      self.disableAddToCartButton(form);
      $('body').loader('show');
      formData.append('upgrade', self.typeQuoteUpgrade());
      $.ajax({
        url: urlBuilder.build('checkout/cart/addtocartvalidation'),
        data: formData,
        type: 'post',
        dataType: 'json',
        cache: false,
        contentType: false,
        processData: false,
        success: function (result) {
          var triggeredAction = self.getTriggeredAction();
          self.formData = form;
          if ((result === null || result === void 0 ? void 0 : result.code) === 'success' || (result === null || result === void 0 ? void 0 : result.code) === 'upgrade-modal' && self.isAddActionTriggered() === true || (result === null || result === void 0 ? void 0 : result.code) === 'new-contract-exists' && self.addNewContract() === true || (result === null || result === void 0 ? void 0 : result.code) === 'guest-new-contract-exists' || result.code === 'subs-limit' && self.isAddActionTriggered() && self.addNewContract() === false) {
            self._ajaxSubmitAction(form);
          } else if ((result === null || result === void 0 ? void 0 : result.code) === 'carehub-login-prompt-payg') {
            $('body').trigger('carehub-login-prompt-payg', form);
          } else if ((result === null || result === void 0 ? void 0 : result.code) === 'super-colleague-deal') {
            confirmModal({
              title: $t('You can only have one Super Colleague Deal registered to your account at one time.'),
              content: $t('To purchase this deal, please delete the other item from your basket'),
              modalClass: 'confirm-popup colleague',
              clickableOverlay: false,
              buttons: [{
                text: $.mage.__('Confirm'),
                class: 'action primary',
                click: function (event) {
                  $('body').loader('hide');
                  this.closeModal(event, true);
                }
              }]
            });
          } else if ((result === null || result === void 0 ? void 0 : result.code) === 'login') {
            $('body').trigger('customer-login-prompt', form);
          } else if ((result === null || result === void 0 ? void 0 : result.code) === 'alternative-deal-quote-locked') {
            confirmModal({
              title: result.message,
              content: result.info,
              clickableOverlay: false,
              buttons: [{
                text: $.mage.__('Finish previous order'),
                class: 'action primary',
                click: function (event) {
                  $('body').trigger('close-all-modals-keep-loader');
                  window.location.href = urlBuilder.build('checkout/');
                }
              }, {
                text: $.mage.__('Start new order'),
                class: 'action secondary',
                click: function (event) {
                  this.closeModal(event, true);
                  self.resetCurrentQuote(form);
                  $('body').loader('hide');
                  self.enableAddToCartButton(form);
                }
              }],
              actions: {
                cancel: function () {
                  $('body').loader('hide');
                  self.enableAddToCartButton(form);
                  $('body').trigger('upgrade-options-submited');
                  $('body').trigger('add-to-cart-button-change-state', {
                    enabled: true
                  });
                }
              }
            });
          } else if ((result === null || result === void 0 ? void 0 : result.code) === 'pending' && self.isLoggedIn() === false) {
            confirmModal({
              title: $t('You almost finished an order earlier'),
              clickableOverlay: false,
              buttons: [{
                text: $.mage.__('Finish previous order'),
                click: function (event) {
                  this.closeModal(event, true);
                  $('body').trigger('close-all-modals-keep-loader');
                  window.location.href = urlBuilder.build('checkout/');
                }
              }, {
                text: $.mage.__('Delete previous order'),
                click: function (event) {
                  this.closeModal(event, true);
                  self.cancelPendingOrder(form, result.data, triggeredAction);
                  $('body').loader('hide');
                  self.enableAddToCartButton(form);
                }
              }],
              actions: {
                cancel: function () {
                  $('body').loader('hide');
                  $('body').trigger('upgrade-options-submited');
                  self.enableAddToCartButton(form);
                  $('body').trigger('add-to-cart-button-change-state', {
                    enabled: true
                  });
                }
              }
            });
          } else if ((result === null || result === void 0 ? void 0 : result.code) === 'pending' && self.isAddActionTriggered() === true) {
            confirmModal({
              title: $t('You almost finished an order earlier'),
              clickableOverlay: false,
              buttons: [{
                text: $.mage.__('Finish previous order'),
                click: function (event) {
                  this.closeModal(event, true);
                  $('body').trigger('close-all-modals-keep-loader');
                  window.location.href = urlBuilder.build('checkout/');
                }
              }, {
                text: $.mage.__('Delete previous order'),
                click: function (event) {
                  this.closeModal(event, true);
                  $('body').trigger('upgrade-options-submited');
                  self.cancelPendingOrder(form, result.data, triggeredAction);
                }
              }],
              actions: {
                cancel: function () {
                  $('body').loader('hide');
                  self.enableAddToCartButton(form);
                  $('body').trigger('upgrade-options-submited');
                  $('body').trigger('add-to-cart-button-change-state', {
                    enabled: true
                  });
                }
              }
            });
          } else if (self.showLimitModal(result === null || result === void 0 ? void 0 : result.code) && self.isAddActionTriggered() === true || ['guest-migrate-limit', 'guest-new-contract-exists', 'guest-pre-order-deal-in-cart', 'guest-back-order-deal-in-cart', 'guest-existing-deal-in-cart-and-adding-back-order', 'guest-existing-deal-in-cart-and-adding-pre-order', 'paym-cart', 'payg-as-you-go-deal', 'payg-paym-mixed-cart'].includes(result === null || result === void 0 ? void 0 : result.code)) {
            let message = result.message,
              info = result.info;
            let primaryButtonLabel = 'Keep my new basket',
              secondaryButtonLabel = 'Restore my previous basket';
            if (['pre-order-deal-in-cart', 'back-order-deal-in-cart', 'guest-pre-order-deal-in-cart', 'guest-back-order-deal-in-cart', 'existing-deal-in-cart-and-adding-back-order', 'existing-deal-in-cart-and-adding-pre-order'].includes(result === null || result === void 0 ? void 0 : result.code)) {
              primaryButtonLabel = 'Change to this deal';
              secondaryButtonLabel = 'Keep my current basket';
            }
            if ((result === null || result === void 0 ? void 0 : result.code) === 'new-contract-exists' || (result === null || result === void 0 ? void 0 : result.code) === 'limit') {
              message = $t('To upgrade or move to pay monthly');
              info = $t('Please remove any other deals from your basket first, then you\'ll be able to upgrade or change a Tesco Mobile from pay as you go to pay monthly.');
            }
            $('body').trigger('dl-one-deal-view-' + (result === null || result === void 0 ? void 0 : result.code));
            confirmModal({
              title: message,
              content: info,
              modalClass: 'confirm-popup',
              clickableOverlay: false,
              buttons: [{
                text: $.mage.__(primaryButtonLabel),
                class: 'action primary',
                click: function (event) {
                  $('body').trigger('dl-one-deal-change-' + result.code);
                  self.resetCurrentQuote(form);
                  this.closeModal(event, true);
                  $('body').trigger('close-all-modals-keep-loader');
                }
              }, {
                text: $.mage.__(secondaryButtonLabel),
                class: 'action secondary',
                click: function (event) {
                  $('body').trigger('dl-one-deal-keep-' + result.code);
                  this.closeModal(event, true);
                  $('body').trigger('upgrade-options-submited');
                  $('body').trigger('close-upgrade-modal-options');
                  $('body').trigger('add-to-cart-button-change-state', {
                    enabled: true
                  });
                  self.enableAddToCartButton(form);
                }
              }],
              actions: {
                cancel: function () {
                  $('body').loader('hide');
                  $('body').trigger('upgrade-options-submited');
                  self.enableAddToCartButton(form);
                  $('body').trigger('add-to-cart-button-change-state', {
                    enabled: true
                  });
                }
              }
            });
          } else if ((result === null || result === void 0 ? void 0 : result.code) === 'guest-backorder-aui' || (result === null || result === void 0 ? void 0 : result.code) === 'backorder-aui') {
            confirmModal({
              title: result.message,
              content: result.info,
              modalClass: 'confirm-popup',
              clickableOverlay: false,
              buttons: [{
                text: $.mage.__('Ok'),
                class: 'action primary',
                click: function (event) {
                  this.closeModal(event, true);
                  $('body').trigger('upgrade-options-submited');
                  $('body').trigger('close-upgrade-modal-options');
                  $('body').trigger('add-to-cart-button-change-state', {
                    enabled: true
                  });
                  self.enableAddToCartButton(form);
                }
              }],
              actions: {
                cancel: function () {
                  $('body').loader('hide');
                  $('body').trigger('upgrade-options-submited');
                  self.enableAddToCartButton(form);
                  $('body').trigger('add-to-cart-button-change-state', {
                    enabled: true
                  });
                }
              }
            });
          } else if (self.showWarningModal(result === null || result === void 0 ? void 0 : result.code) && self.isAddActionTriggered() === true || (result === null || result === void 0 ? void 0 : result.code) === 'limit' || (result === null || result === void 0 ? void 0 : result.code) === 'error' || (result === null || result === void 0 ? void 0 : result.code) === 'invalid-dynamic-bundle-option' || (result === null || result === void 0 ? void 0 : result.code) === 'paym-customer-cannot-add-fusion' || (result === null || result === void 0 ? void 0 : result.code) === 'paym-customer-cannot-add-payg-essentials') {
            var limitTemplate = mageTemplate(limitTmp),
              infoData = _.extend({}, {
                content: result.message
              });
            confirmModal({
              title: $t('Warning'),
              clickableOverlay: false,
              content: limitTemplate({
                data: infoData
              }),
              buttons: [{
                text: $.mage.__('Ok'),
                class: 'action primary',
                click: function (event) {
                  this.closeModal(event, true);
                  $('body').loader('hide');
                  $('body').trigger('upgrade-options-submited');
                  self.enableAddToCartButton(form);
                  $('body').trigger('add-to-cart-button-change-state', {
                    enabled: true
                  });
                }
              }],
              actions: {
                cancel: function () {
                  $('body').loader('hide');
                  $('body').trigger('upgrade-options-submited');
                  self.enableAddToCartButton(form);
                  $('body').trigger('add-to-cart-button-change-state', {
                    enabled: true
                  });
                }
              }
            });
          } else if (self.showUpgradeOptionsModal(result.code)) {
            $('body').trigger('customer-ajax-logged-in', form);
            $('body').trigger('upgrade-options-submited');
          }
          self.getQuoteType();
          self.typeQuoteUpgrade(false);
          self.typeQuoteMigration(false);
          self.addNewContract(false);
          $('body').trigger('processStop');
        }
      });
    },
    isLoggedIn: function () {
      var customer = customerData.get('customer');
      return !!customer().firstname;
    },
    isAddActionTriggered: function () {
      return this.typeQuoteUpgrade() === true || this.typeQuoteMigration() === true || this.addNewContract() === true;
    },
    getTriggeredAction: function () {
      if (this.typeQuoteUpgrade() === true) {
        return 'upgrade';
      } else if (this.typeQuoteMigration() === true) {
        return 'migrate';
      }
      return 'new-contract';
    },
    triggerAddAction: function (actionToTrigger) {
      if (actionToTrigger === 'upgrade') {
        this.typeQuoteUpgrade(true);
      } else if (actionToTrigger === 'migrate') {
        this.typeQuoteMigration(true);
      } else {
        this.addNewContract(true);
      }
    },
    getQuoteType: function () {
      if (this.typeQuoteUpgrade() === true) {
        this.quoteType('UPGRADE');
      } else if (this.typeQuoteMigration() === true) {
        this.quoteType('PAYG_MIGRATION');
      } else if (this.addNewContract() === true) {
        this.quoteType('NEW_CONTRACT');
      }
    },
    showUpgradeOptionsModal: function (code) {
      const upgradeOptionsModalCodes = ['upgrade-modal', 'new-contract-exists', 'migrate-limit', 'upgrade-limit', 'pending', 'address-changed-recently', 'pending-deactivate', 'limit', 'subs-limit', 'overdue-balance', 'pre-order-deal-in-cart', 'back-order-deal-in-cart', 'existing-deal-in-cart-and-adding-pre-order', 'existing-deal-in-cart-and-adding-back-order', 'payg-as-you-go-deal', 'payg-paym-mixed-cart'];
      return upgradeOptionsModalCodes.find(item => item === code) !== undefined && this.isAddActionTriggered() === false;
    },
    showLimitModal: function (code) {
      return code === 'upgrade-limit' || code === 'migrate-limit' || code === 'pre-order-deal-in-cart' || code === 'back-order-deal-in-cart' || code === 'existing-deal-in-cart-and-adding-back-order' || code === 'existing-deal-in-cart-and-adding-pre-order' || (code === 'new-contract-exists' || code === 'limit') && (this.typeQuoteUpgrade() === true || this.typeQuoteMigration() === true);
    },
    showWarningModal: function (code) {
      const warningModalCodes = ['limit', 'subs-limit', 'overdue-balance', 'pending-deactivate', 'address-changed-recently', 'new-contract-exists'];
      if (code === 'subs-limit' && (this.typeQuoteUpgrade() === true || this.typeQuoteMigration() === true)) {
        return false;
      }
      return warningModalCodes.find(item => item === code) !== undefined;
    }
  };
  return function (widget) {
    $.widget('mage.catalogAddToCart', widget, mixin);
    return $.mage.catalogAddToCart;
  };
});

